export class College {
    public name: string;
    public id: string;
    public zone: Phaser.Geom.Rectangle;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
        this.zone = null;
    }
}



// WEBPACK FOOTER //
// ./src/games/UniversityGame/objects/College.ts